import React, { memo, useMemo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Paper, Grid, Typography } from '@mui/material';
import { useMessage } from 'modules/intl';
import { TimeSignalDimensionType } from 'graphql/types';
import { useGetTimeSignalAnalyticsData } from 'modules/Insights/Notes/hooks/useGetTimeSignalAnalyticsData';
import PieChart from './PieChart';
import LabelChartSkeleton from './LabelChartSkeleton';
import { LabelNoData } from './LabelNoData';
import { transformLabelData } from './utils';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    marginRight: theme.spacing(3),
    maxHeight: theme.spacing(32.5),
    minHeight: theme.spacing(32.5)
  },
  typography: {
    color: theme.palette.text.secondary,
    fontWeight: 600
  }
}));

export const TaskChart: React.FC = () => {
  const classes = useStyles();
  const name = useMessage('insights.timeSheetLabels.tasks');
  const { data, loading = true, isEmpty } = useGetTimeSignalAnalyticsData(
    TimeSignalDimensionType.MetricsByTask
  );
  const dataset = useMemo(() => {
    if (isEmpty) {
      return [];
    } else {
      return transformLabelData(data?.timeSignalAnalytics?.items, 'TASK');
    }
  }, [data?.timeSignalAnalytics?.items, isEmpty]);

  return (
    <Paper
      elevation={3}
      data-testid={'source-by-task-chart-container'}
      className={classes.container}
    >
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <Typography
            className={classes.typography}
            variant="body1"
            data-testid="task-chart-title"
          >
            {name}
          </Typography>
        </Grid>
        <Grid item>
          {loading ? (
            <LabelChartSkeleton />
          ) : isEmpty ? (
            <LabelNoData />
          ) : (
            <PieChart data={dataset} labelType="TASK" />
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};
export default memo(TaskChart);
